import { GenericError } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import React from 'react';
import { BannerTemplate } from "../../CustomerPrivacyAndSecurityTab/CustomerPrivacyAndSecurityTab.styles";
const handleAppTrustError = (appTrustError, refetch) => {
  /**
   * 404s are handled differently for GET APIs, for ex:
   * - Customer side may still choose to render QnA with answer being
   * 'response not provided'
   * - partner side may default to opening the form when live API
   * throws this
   * In either of the cases, we needn't show any error banner, but let
   * the caller handle this
   */
  if (appTrustError && appTrustError.status !== 404) {
    log.error('PrivacyAndSecurityTab', 'REST API error', {
      error: appTrustError
    });
    return /*#__PURE__*/React.createElement(BannerTemplate, null, /*#__PURE__*/React.createElement(GenericError, {
      type: appTrustError.status === 'unknown' ? 'network' : 'loading',
      onTryAgainClick: refetch
    }));
  }
};
export const getPrivacySecurityError = (appListingError, liveAppTrustError, draftAppTrustError, refetch) => {
  if (appListingError) {
    log.error('PrivacyAndSecurityTab', 'GraphQL Error', {
      error: appListingError
    });
    return /*#__PURE__*/React.createElement(BannerTemplate, null, /*#__PURE__*/React.createElement(GenericError, {
      type: "loading"
    }));
  }
  const draftError = handleAppTrustError(draftAppTrustError, refetch);
  if (draftError) return draftError;
  const liveError = handleAppTrustError(liveAppTrustError, refetch);
  if (liveError) return liveError;
  return null;
};
export default getPrivacySecurityError;